import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  SERIES_UPDATE_LOADING,
  SERIES_UPDATE_ERROR,
  SERIES_UPDATE_START,
  SERIES_UPDATE_SUCCESS,
  SERIES_UPDATE_CANCEL,
} from '@src/app/accounts/series-update/actions';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
export type State = {
  readonly loading: boolean;
  seriesUpdateSavedResult: Object | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case SERIES_UPDATE_ERROR:
      case SERIES_UPDATE_START:
      case OMS_LOOKUP_SUCCESS:
        return false;
      case SERIES_UPDATE_LOADING:
        return action.payload;
      default:
        return state;
    }
  },

  seriesUpdateSavedResult: (state = null, action) => {
    switch (action.type) {
      case SERIES_UPDATE_SUCCESS:
      case SERIES_UPDATE_ERROR:
        return action.payload;
      case SERIES_UPDATE_CANCEL:
      case SERIES_UPDATE_START:
        return null;
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/series-update/reducer.ts